import { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { API, useAuth } from "./AuthContext";
import { MODULE_PATHS } from "../constants/moduleAccess";

const ModuleAccessContext = createContext(null);

export function moduleForPath(path) {
  return Object.keys(MODULE_PATHS).find(id => MODULE_PATHS[id].some(prefix => path === prefix || path.startsWith(`${prefix}/`)));
}

export function ModuleAccessProvider({ children }) {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const identity = user?._id || user?.id;
  const [result, setResult] = useState(null);
  const [error, setError] = useState(false);
  const [revision, setRevision] = useState(0);
  const key = `${identity || ""}:${user?.role || ""}:${pathname}`;
  const refresh = useCallback(() => setRevision(n => n + 1), []);
  useEffect(() => {
    let cancelled = false;
    setResult(current => current?.key === key ? current : null);
    setError(false);
    if (!user) return () => { cancelled = true; };
    axios.get(`${API}/settings/module-access`, { withCredentials: true }).then(({ data }) => {
      if (!cancelled) setResult({ key, data });
    }).catch(() => { if (!cancelled) setError(true); });
    return () => { cancelled = true; };
  }, [identity, user?.role, pathname, revision]);
  const access = result?.key === key ? result.data : null;
  return <ModuleAccessContext.Provider value={{ access, error, refresh }}>{children}</ModuleAccessContext.Provider>;
}

export function useModuleAccess() { return useContext(ModuleAccessContext); }

export function ModuleRouteGate({ children }) {
  const { pathname } = useLocation();
  const { access, error, refresh } = useModuleAccess();
  const moduleId = moduleForPath(pathname);
  const concedido = useRef(false);
  if (!moduleId) return children;
  if (error) return <div className="p-8 text-center" role="alert">No se pudo comprobar el acceso. <button onClick={refresh} className="underline">Reintentar</button></div>;
  // Pestañas: mientras se revalida el acceso de otra ruta no se desmonta lo ya concedido (los borradores siguen vivos).
  if (!access) return concedido.current ? children : <div className="p-8 text-center">Comprobando acceso...</div>;
  if (access.modules[moduleId] !== true) { concedido.current = false; return <div className="p-8 text-center" role="alert">No tienes acceso a esta sección.</div>; }
  concedido.current = true;
  return children;
}
